import http from '../httpService';

export function getBankRiskProfile(cycleId) {
  return http.get(`/bank-risk-profile-forms?cycleId.equals=${cycleId}`)
}
export function getBankRiskProfileOverallRiskAssessmentLevel() {
  return http.get(`/bank-risk-profile-overall-risk-assessment-levels`)
}
export function createBankRiskProfile (payload) {
  return http.post('/bank-risk-profile-forms',payload)
}

export function editBankRiskProfile(id,payload) {
  return http.put(`/bank-risk-profile-forms/${id}`,payload)
}